<template>
  <component
    :is="tag"
    v-if="tagType"
    :style="{
      color: 'white',
      backgroundColor: tagType.color,
      fontSize: '0.625rem',
      fontWeight: 'bold',
      textAlign: 'center'
    }"
  >
    {{ tagType.label }}
  </component>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    },

    tag: {
      type: String,
      default: 'div'
    }
  },

  computed: {
    tagType() {
      switch (this.type) {
        case 'act':
          return {
            label: 'ขายฝาก',
            color: '#8fbe00'
          }

        case 'ext':
          return {
            label: 'รอต่อขายฝาก',
            color: '#f5a623'
          }

        case 'exp':
          return {
            label: 'หลุดขายฝาก',
            color: '#d0021b'
          }

        case 'rdm':
          return {
            label: 'ไถ่ถอน',
            color: '#9b9b9b'
          }

        case 'dis':
          return {
            label: 'ตัดขายฝาก',
            color: '#5a5a5a'
          }

        default:
          return null
      }
    }
  }
}
</script>
